module.exports = __webpack_public_path__ + "img/sankaku_44_red.02db30c5.png";